/**
 * Adapted from JFE:
 * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/browse/src/packages/common-legacy-do-not-add-anything-new/src/util/get-all-feature-flags.js
 *
 */

import memoizeOne from 'util/memoize-one';
import type { Flags } from '../types';
import { getFeatureFlagsFromMetaTag } from '../utils';

// ajs-fe-feature-flags contains ALL frontend flags (boolean, string and JSON flags)
export const nonMemoizedGetAllFeatureFlags = (): Flags => getFeatureFlagsFromMetaTag('ajs-fe-feature-flags');
// @ts-ignore
export default memoizeOne(nonMemoizedGetAllFeatureFlags);
